import { useMemo }             from 'react';
import { connect }             from 'react-redux';
import { reducerType }         from 'reducer';
import { sizeStateType }       from 'reducer/types';
import { colors }              from 'utils/colors';

type ButtonType = {
  sizeState: sizeStateType;
  props:     { [key: string]: any; };
}

const Button: React.FC<ButtonType> = ({ props, sizeState }) => {

const style = useMemo(() => {

  const bigScreen = sizeState.wideScreen && sizeState.longScreen;

  return{
      border:   props['manualVal'] === props['txt'] ? `4px solid ${ colors.blue }` : 'none',
      maxWidth: bigScreen ? undefined : '30%',
      height:   bigScreen ? undefined : 33,
      fontSize: bigScreen ? undefined : 17

    };
},[props, sizeState])

return (
  <div
     className = { props['class'] }
     onClick   = { props['func'] }
     style     = { style }
  >
     { props['txt'] }
  </div>
 );
}



const mapStateToProps = (reducer: reducerType) => {
  return {
     sizeState:  reducer.size,
}};

export default connect(mapStateToProps)(Button);
